import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types'
import {isObject} from "../helpers/utils";
import {DownloadPdf} from "../reducers/files";


class ComparisonResult extends Component {

  render () {
    const {source,DownloadPdf, processing} = this.props;
   
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete('tid');
    const gotonewcompare=1;
    return [//przycis w raporcie
      <div className="default-block container" key={1}>
        <div className="wp-block-buttons">
          <div className="default-block container" style={{textAlign: 'center', width: 'auto'}}>
            <div className="wp-block-button" style={{margin: 0}}>            
              <button className="wp-block-button__link download-pdf-button"
                      style={{borderRadius: 5, backgroundColor: '#25376B'}}
                      disabled={processing}
                      onClick={DownloadPdf}>{processing ? 'Generowanie raportu...' : 'Pobierz pełny raport'}</button>
            </div>
          </div>
        </div>
      </div>,
  //wyswietlanie kawalka tekstu
      <div className="default-block container" key={3}>
        <h2 style={{marginBottom: 50, textAlign: 'center', fontWeight: 600}}>Tekst Pracy<span style={{display: 'block', fontWeight: 'normal', fontSize: 'initial'}}>(fragment)</span></h2>
      </div>,
  //tabela wynikow dla fraz
      <div className="default-block container" key={4}>
        <p className="jsa-demo-comparison-result">
          {source.map(({orth, lowRisk5, lowRisk10, highRisk5, highRisk10}, idx) => {
            let lowRisk = lowRisk5 || lowRisk10 ? 'risk-type-LOW' : '';
            let highRisk = highRisk5 || highRisk10 ? 'risk-type-HIGH' : '';
            if (idx > 0 && idx < source.length - 1) {
              if (!lowRisk && (source[idx - 1].lowRisk5 || source[idx - 1].lowRisk10) && (source[idx + 1].lowRisk5 || source[idx + 1].lowRisk10)) {
                lowRisk = 'risk-type-LOW'
              }
              if (!highRisk && (source[idx - 1].highRisk5 || source[idx - 1].highRisk10) && (source[idx + 1].highRisk5 || source[idx + 1].highRisk10)) {
                highRisk = 'risk-type-HIGH'
              }
            }
            
            return <span className={`${lowRisk} ${highRisk}`} key={idx}>{/[.,;:'"%?!]/.test(orth) ? orth : ` ${orth}`}</span>;
          })}{source.length >= 1000 ? '...' : ''}
        </p>
      </div>,
  
      <div className="default-block container" key={5}>
        <div className="wp-block-buttons">
          <div className="default-block container" style={{textAlign: 'center', width: 'auto'}}>
            <div className="wp-block-button" style={{margin: 0}}>
              <button
                 className="wp-block-button__link download-pdf-button"
                 style={{borderRadius: 5, backgroundColor: '#f54d4d', fontFamily: 'Arial'}}
                 disabled={processing}
                 onClick={()=>{
                      DownloadPdf({gotonewcompare}); 
                     }}>Porównaj nowy dokument</button>
            </div>
          </div>
        </div>
      </div>
    ]
  }
}

ComparisonResult.propTypes = {
  source: PropTypes.array,
  getComparisonPdf: PropTypes.func,
  DownloadPdf:PropTypes.func,
  processing: PropTypes.bool
  
};

ComparisonResult.defaultProps = {
  source: [],
  DownloadPdf: () => {},  
  processing: false
};

export default connect(
  ({report, processing}) => ({
    source: isObject(report) && Array.isArray(report.source) ? report.source : [],
    processing
  }),
  {DownloadPdf}
)(ComparisonResult);
